var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay && _vm.showRule !== "render"
    ? _c(
        "div",
        {
          staticClass: "preview-item_text",
          style: {
            width: _vm.width,
            fontSize: _vm.title + "px",
            fontWeight: _vm.wordWeight,
            color: _vm.color,
            "padding-left": _vm.paddingLeft
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.labelName) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35d4f35a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d4f35a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemText.vue
// module id = null
// module chunks = 